import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import groupBy from 'lodash/groupBy'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  modalAction,
  confidentialAction,
  employeeAction,
  employeeLevelsAction,
  lobAction,
  companyAction,
  positionAction,
} from './../../actions/'
import {
  modalSelector,
  confidentialSelector,
  employeeSelector,
  employeeLevelsSelector,
  lobSelector,
  companySelector,
  positionSelector,
} from './../../selectors'
import { searchConfidentials } from '../../function'
import CustomModal from '../../components/modal'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditConfidential from './edit'
import ListConfidential from './list'
import ConfidentialForm from '../../components/confidential'
import CustomModalMessage from '../../components/modal-message'

class ConfidentialPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      lob_list: [],
      emp_level_list: [],
      employee_list: [],
      company_list: [],
      position_list: [],
      confidential_list: [],
      confidential_group: null,
      edit: false,
      span: false,
      employee_confidential: '',
      user_id: '',
      other_income: 0,
      salary: 0,
      start_date: '',
      end_date: '',
      company_name: '',
      position_name: '',
      lob_name: '',
      emp_level: '',
      emp_level_id: '',
      id: '',
      isOK: false,
      is_active: true,
      search: '',
      defaultConfidentials: [],
      confidentials: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.handleEmployee = this.handleEmployee.bind(this)
    this.handleLevel = this.handleLevel.bind(this)
    this.groupByConfidential = this.groupByConfidential.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.showImport = this.showImport.bind(this)
    this.cancelImport = this.cancelImport.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }
  componentDidMount() {
    this.props.listConfidential(localStorage.getItem('access_token'))
    this.props.listEmployee(localStorage.getItem('access_token'))
    this.props.listLevel(localStorage.getItem('access_token'))
    this.props.listLOB(localStorage.getItem('access_token'))
    this.props.listCompany(localStorage.getItem('access_token'))
    this.props.listPosition(localStorage.getItem('access_token'))
  }
  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'lobList')) {
      this.setState({ lob_list: get(nextProps, 'lobList') })
    }
    if (get(nextProps, 'levelList')) {
      this.setState({ emp_level_list: get(nextProps, 'levelList') })
    }
    if (get(nextProps, 'employeeList')) {
      this.setState({ employee_list: get(nextProps, 'employeeList') })
    }
    if (get(nextProps, 'confidentialList')) {
      this.setState({ confidential_list: get(nextProps, 'confidentialList') })
    }
    if (get(nextProps, 'positionList')) {
      this.setState({ position_list: get(nextProps, 'positionList') })
    }
    if (get(nextProps, 'companyList')) {
      this.setState({ company_list: get(nextProps, 'companyList') })
    }
    if (get(nextProps, 'confidentialCreate.confidentialCreate')) {
      this.props.showModal(
        'confidential',
        get(nextProps, 'confidentialCreate.status'),
        get(nextProps, 'confidentialCreate.message')
      )
      this.props.listConfidential(localStorage.getItem('access_token'))
      this.props.resetCreateConfidential()
    }
    if (get(nextProps, 'confidentialEdit.confidentialEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'confidential',
        get(nextProps, 'confidentialEdit.status'),
        get(nextProps, 'confidentialEdit.message')
      )
      if (get(nextProps, 'confidentialEdit.status') === 200) this.showSave()
      this.props.listConfidential(localStorage.getItem('access_token'))
      this.props.resetEditConfidential()
      this.handleClickEdit(false, '')
    }
    if (get(nextProps, 'confidentialDeactivate.confidentialDeactivate')) {
      this.props.showConfirm(
        'deleteConfidential',
        get(nextProps, 'confidentialDeactivate.status'),
        get(nextProps, 'confidentialDeactivate.message')
      )
      this.props.listConfidential(localStorage.getItem('access_token'))
      this.props.resetDeactivateConfidential()
    }
    if (get(nextProps, 'confidentialList') && this.state.search === '') {
      this.setState({
        confidentials: get(nextProps, 'confidentialList'),
        defaultConfidentials: get(nextProps, 'confidentialList'),
        isOK: false,
      })
    }
    if (get(nextProps, 'exportURL')) {
      window.open(get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportConfidential()
    }
    if (get(nextProps, 'confidentialImport')) {
      const import_result = get(nextProps, 'confidentialImport')
      this.showImport(import_result)
      this.props.listConfidential(localStorage.getItem('access_token'))
      this.props.resetImportConfidential()
    }
  }
  groupByConfidential(data) {
    const groupByUserID = groupBy(data, 'user_id')
    let groupByStartDate
    const newConfidential = []
    const groupConfidential = []
    Object.keys(groupByUserID).map(key => {
      groupByStartDate = groupByUserID[key]
      groupConfidential.push(orderBy(groupByStartDate, 'start_date', 'desc'))
      newConfidential.push(orderBy(groupByStartDate, 'start_date', 'desc')[0])
      return key
    })
    this.setState({
      isOK: false,
    })
    return { newConfidential, groupConfidential }
  }
  groupConfidentialByUser(users, confidentials, lobs, levels, companys, positions) {
    const tempCon = []
    for (let i = 0; i < confidentials.length; i++) {
      for (let j = 0; j < users.length; j++) {
        if (confidentials[i].user_id === users[j]._id && !users[j].is_init_user) {
          tempCon.push(confidentials[i])
          break
        }
      }
    }

    const confidential = this.groupByConfidential(tempCon).newConfidential
    const confidential_group = this.groupByConfidential(tempCon).groupConfidential
    const temp = []
    const temp_group = []

    if (confidential === undefined || confidential_group === undefined) return
    confidential.map((con, key) => {
      for (let i = 0; i < users.length; i++) {
        if (users[i]._id === con.user_id) {
          temp.push({
            _id: con._id,
            emp_code: users[i].emp_code,
            emp_name: `${users[i].first_name} ${users[i].last_name}`,
            lob: this.findLOB(users[i].lob_id, lobs),
            level: this.findPayGradeName(con.emp_level_id, levels),
            company: this.findCompany(users[i].company_id, companys),
            position: this.findPosition(users[i].position_id, positions),
            start_date: con.start_date,
            salary: con.salary,
            other_income: con.other_income,
          })
        }
      }
      return con
    })
    let group
    Object.keys(confidential_group).map(key => {
      group = confidential_group[key]
      for (let i = 0; i < users.length; i++) {
        group.map((g, key) => {
          if (users[i]._id === g.user_id) {
            temp_group.push({
              _id: g._id,
              emp_code: users[i].emp_code,
              emp_name: `${users[i].first_name} ${users[i].last_name}`,
              lob: this.findLOB(users[i].lob_id, lobs),
              level: this.findPayGradeName(g.emp_level_id, levels),
              company: this.findCompany(users[i].company_id, companys),
              position: this.findPosition(g.position_id, positions),
              salary: g.salary,
              other_income: g.other_income,
              start_date: g.start_date,
              end_date: g.end_date,
            })
          }
          return g
        })
      }
      return key
    })
    this.setState({ confidentials: temp, defaultConfidentials: temp, confidential_group: temp_group, isOK: true })
  }
  findPosition(id, positions) {
    for (let i = 0; i < positions.length; i++) {
      if (positions[i]._id === id) {
        return positions[i].name
      }
    }
    return ''
  }
  findCompany(id, companys) {
    for (let i = 0; i < companys.length; i++) {
      if (companys[i]._id === id) {
        return companys[i].name
      }
    }
    return ''
  }
  findLOB(id, lobs) {
    for (let i = 0; i < lobs.length; i++) {
      if (lobs[i]._id === id) {
        return lobs[i].name
      }
    }
    return ''
  }
  findPayGradeName(id, levels) {
    for (let i = 0; i < levels.length; i++) {
      if (levels[i]._id === id) {
        return levels[i].name
      }
    }
    return ''
  }
  handleClickSearch() {
    this.setState({ confidentials: get(this.state, 'defaultConfidentials').filter(searchConfidentials, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ confidentials: get(this.state, 'defaultConfidentials'), search: '' })
    else this.setState({ search: e.target.value })
  }
  handleClickEdit(editConfidential, confidential_id) {
    this.setState({
      edit: editConfidential,
      id: confidential_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  handleEmployee(e) {
    this.setState({
      employee_confidential: e,
      user_id: e.user_id,
      company_name: this.findCompany(e.company_id, this.state.company_list),
      lob_name: this.findLOB(e.lob_id, this.state.lob_list),
      position_name: this.findPosition(e.position_id, this.state.position_list),
    })
  }
  handleLevel(e) {
    this.setState({
      emp_level: e,
      emp_level_id: e.level_code,
    })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your confidential information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('confidentialForm')
  }
  cancelForm() {
    this.props.hideModal('confidentialForm')
  }
  cancelAlert() {
    this.props.hideModal('confidential')
  }
  showImport(result) {
    this.props.showConfirm('confirmImport', 'Import Result', result)
  }
  cancelImport() {
    this.props.hideConfirm('confirmImport')
  }
  submitForm() {
    this.props.createConfidential(
      {
        user_id: get(this.state, 'user_id'),
        emp_level_id: this.state.emp_level_id,
        salary: this.state.salary,
        start_date: moment(this.state.start_date),
        other_income: this.state.other_income,
      },
      localStorage.getItem('access_token'))
    this.setState({
      start_date: '',
      user_id: '',
      emp_level_id: '',
      salary: 0,
      other_income: 0,
      company_name: '',
      lob_name: '',
      position_name: '',
    })
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectConfidential.isAuthenticated')
    const redirect = get(this.props, 'redirectConfidential.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (get(this.state, 'confidential_list.length') !== 0
      && get(this.state, 'employee_list.length') !== 0
      && get(this.state, 'emp_level_list.length') !== 0
      && get(this.state, 'lob_list.length') !== 0
      && get(this.state, 'position_list.length') !== 0
      && get(this.state, 'company_list.length') !== 0
      && !get(this.state, 'isOK')) {
      this.groupConfidentialByUser(
        get(this.state, 'employee_list'),
        get(this.state, 'confidential_list'),
        get(this.state, 'lob_list'),
        get(this.state, 'emp_level_list'),
        get(this.state, 'company_list'),
        get(this.state, 'position_list')
      )
    }
    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const buttonClose = (
      <div>
        <NewButton color="info" onClick={ this.cancelImport }>Close</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetchingEmployee')
    || get(this.props, 'getIsFetchingLOB')
    || get(this.props, 'getIsFetchingPosition')
    || get(this.props, 'getIsFetchingCompany')
    || get(this.props, 'getIsFetchingLevel')
    || get(this.props, 'getIsFetchingConfidential')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          import={ (payload) => this.props.importConfidential(payload, localStorage.getItem('access_token')) }
          export={ () => this.props.exportConfidential(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        {
          get(this.props, 'modalType') === 'confidential' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ get(this.props, 'modalType') === 'confidential' }
              type={ get(this.props, 'modalStatus') }
              message={ get(this.props, 'modalMessage') }
            />
        }
        {
          get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ get(this.props, 'confirmType') === 'confirmSave' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          get(this.props, 'confirmType') === 'deleteConfidential' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ get(this.props, 'confirmType') === 'deleteConfidential' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          get(this.props, 'confirmType') === 'confirmImport' &&
          <CustomModalMessage
            hide={ this.cancelImport }
            flag={ 'confirmImport' }
            show={ get(this.props, 'confirmType') === 'confirmImport' }
            type={ get(this.props, 'confirmStatus') }
            created={ get(this.props, 'confirmMessage.createdEmployeeConfidentials') }
            updated={ get(this.props, 'confirmMessage.updatedEmployeeConfidentials') }
            errors={ get(this.props, 'confirmMessage.errors') }
            button={ buttonClose }
          />
        }
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <Row noGutters>
          <Col>
            <ListConfidential
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              confidential={ this.state.confidentials }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditConfidential
                edit={ this.state }
                confidential={ this.state.data }
                confidential_group={ this.state.confidential_group }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ get(this.props, 'confrimType') }
                confirmStatus={ get(this.props, 'confirmStatus') }
                confirmType={ get(this.props, 'confirmType') }
                confirmMessage={ get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ get(this.props, 'modalType') === 'confidentialForm' } toggle={ this.cancelForm }>
          <ConfidentialForm
            create={ true }
            button={ button }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleEmployee={ this.handleEmployee }
            handleLevel={ this.handleLevel }
            handleInput={ this.handleInput }
            employee_list={ this.state.employee_list }
            employee_confidential={ this.state.employee_confidential }
            user_id={ this.state.user_id }
            lob_name={ this.state.lob_name }
            emp_level_list={ this.state.emp_level_list }
            emp_level={ this.state.emp_level }
            emp_level_id={ this.state.emp_level_id }
            position_list={ this.state.position_list }
            position_name={ this.state.position_name }
            company_name={ this.state.company_name }
            salary={ this.state.salary }
            start_date={ this.state.start_date }
            end_date={ this.state.end_date }
            other_income={ this.state.other_income }
            is_active={ this.state.is_active }
            confirm={ get(this.props, 'modalType') }
            cancelForm={ this.cancelForm }
            modalStatus={ get(this.props, 'modalStatus') }
            modalType={ get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

ConfidentialPage.propTypes = {
  createConfidential: PropTypes.func.isRequired,
  listConfidential: PropTypes.func.isRequired,
  resetCreateConfidential: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  resetEditConfidential: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  redirectConfidential: confidentialSelector.redirectConfidential,
  getIsFetchingConfidential: confidentialSelector.getIsFetching,
  getIsFetchingEmployee: employeeLevelsSelector.getIsFetching,
  getIsFetchingLOB: lobSelector.getIsFetching,
  getIsFetchingPosition: positionSelector.getIsFetching,
  getIsFetchingCompany: companySelector.getIsFetching,
  getIsFetchingLevel: employeeLevelsSelector.getIsFetching,
  confidentialCreate: confidentialSelector.getCreateConfidentialData,
  confidentialEdit: confidentialSelector.getEditConfidentialData,
  confidentialGet: confidentialSelector.getGetConfidentialData,
  confidentialDeactivate: confidentialSelector.getDeactivateConfidential,
  confidentialList: confidentialSelector.getListConfidential,
  confidentialImport: confidentialSelector.getImportResult,
  exportURL: confidentialSelector.getExportURL,
  employeeList: employeeSelector.getListUser,
  lobList: lobSelector.getListLOB,
  levelList: employeeLevelsSelector.getListEmployeeLevels,
  companyList: companySelector.getListCompany,
  positionList: positionSelector.getListPosition,
})(state, props)
const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    showModal: modalAction.showModal,
    hideModal: modalAction.hideModal,
    showConfirm: modalAction.showConfirm,
    hideConfirm: modalAction.hideConfirm,
    resetAuth: authAction.resetAuth,
    createConfidential: confidentialAction.createConfidential,
    editConfidential: confidentialAction.editConfidential,
    getConfidential: confidentialAction.getConfidential,
    listConfidential: confidentialAction.getConfidential,
    resetCreateConfidential: confidentialAction.resetCreateConfidential,
    resetEditConfidential: confidentialAction.resetEditConfidential,
    exportConfidential: confidentialAction.exportConfidential,
    resetDeactivateConfidential: confidentialAction.resetDeactivateConfidential,
    importConfidential: confidentialAction.importConfidential,
    resetImportConfidential: confidentialAction.resetImportConfidential,
    resetExportConfidential: confidentialAction.resetExportConfidential,
    listEmployee: employeeAction.getUser,
    listLOB: lobAction.getLOB,
    listLevel: employeeLevelsAction.getEmployeeLevels,
    listCompany: companyAction.getCompany,
    listPosition: positionAction.getPosition,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(ConfidentialPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/confidential/index.js